export default __webpack_public_path__ + "static/media/7 - A Walk.a77c700b.jpg";